import * as React from 'react'
import { useState, useContext } from 'react'
import { callZapier } from 'utils/zapier/callZapier'
import { IntakeContext } from 'context/IntakeContext'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import EditIcon from '@mui/icons-material/Edit'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Slide from '@mui/material/Slide'
import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material'

function createData(icon, description, link) {
  return { icon, description, link }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const rows = [
  createData(
    <EditIcon fontSize="medium" />,
    'Improve My Legacy Gap',
    `Let's do it!`
  ),
]

export default function LifeInsuranceRecommendations() {
  const { intakeState } = useContext(IntakeContext)
  const [openDialogModal, setOpenDialogModal] = useState(false)
  const improveScoreHelp = () => {
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/3zmzqpy/',
      payload: {
        user: {
          firstName: intakeState.firstName,
          lastName: intakeState.lastName,
          phoneNumber: intakeState.phone,
          email: intakeState.email,
        },
      },
      sendNotification: true,
      notificationMessage:
        'A member of the PARCO team will reach out to you shortly! Expect a call to help improve your retirement readiness.',
    })
  }
  const handleDialogModalOpen = () => {
    setOpenDialogModal(true)
  }
  const handleDialogModalClose = () => {
    setOpenDialogModal(false)
  }
  const handleCallMeClose = () => {
    improveScoreHelp()
    setOpenDialogModal(false)
  }
  const handleScheduleCallClose = () => {
    setOpenDialogModal(false)
  }
  return (
    <>
      <Dialog
        open={openDialogModal}
        TransitionComponent={Transition}
        onClose={handleDialogModalClose}
        aria-labelledby="improve-score-dialog-title"
        aria-describedby="improve-score-dialog-description"
      >
        <DialogTitle
          id="improve-score-dialog-title"
          sx={{ paddingRight: '40px' }}
        >
          {'A PARCO Team Member is ready to help!'}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDialogModalClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#344767',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ paddingTop: '0px' }}>
          <DialogContentText id="improve-score-dialog-description">
            Let us know when we can contact you so we can work on improving your
            PARCO Legacy Gap!
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Button
            rel="noreferrer"
            size="large"
            variant="contained"
            sx={[
              {
                padding: '10px 24px 9px',
                backgroundColor: '#344767',
                color: '#fff',
                fontWeight: 'normal',
                boxShadow: 'none',
                marginBottom: { xs: '8px', sm: '0px' },
              },
              {
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#293852',
                  boxShadow: 'none',
                },
              },
            ]}
            onClick={handleCallMeClose}
          >
            CALL ME NOW
          </Button>
          <Button
            rel="noreferrer"
            size="large"
            variant="contained"
            sx={[
              {
                padding: '10px 24px 9px',
                backgroundColor: '#344767',
                color: '#fff',
                fontWeight: 'normal',
                boxShadow: 'none',
              },
              {
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#293852',
                  boxShadow: 'none',
                },
              },
            ]}
            href="https://team_parco.apptoto.com/"
            target="_blank"
            onClick={handleScheduleCallClose}
          >
            SCHEDULE A CALL
          </Button>
        </DialogActions>
      </Dialog>
      <TableContainer
        component={Paper}
        sx={{ borderRadius: 1, boxShadow: 0, border: '1px solid #ddd' }}
      >
        <Table aria-label="Task Recommendations" size="small">
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.icon}
                sx={{
                  '&:last-child td': { border: 0 },
                  'td:first-of-type': {
                    padding: '10px 0px 4px 16px',
                    width: '1%',
                  },
                  'td:last-of-type': {
                    color: '#3498DB',
                  },
                  td: {
                    fontSize: '18px',
                  },
                }}
              >
                <TableCell component="td" scope="row">
                  {row.icon}
                </TableCell>
                <TableCell align="left">{row.description}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="text"
                    size="small"
                    sx={[
                      {
                        fontSize: '14px',
                        color: '#344767',
                        border: '1px solid #344767',
                        padding: '6px 12px',
                        borderRadius: '4px',
                        textTransform: 'capitalize',
                      },
                      {
                        '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                          transform: 'none',
                          backgroundColor: '#eaecef',
                          boxShadow: 'none',
                          color: '#344767',
                        },
                      },
                    ]}
                    onClick={handleDialogModalOpen}
                  >
                    {row.link}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
